import { render, staticRenderFns } from "./maUrl.vue?vue&type=template&id=5bd8e550&scoped=true&"
import script from "./maUrl.vue?vue&type=script&lang=js&"
export * from "./maUrl.vue?vue&type=script&lang=js&"
import style0 from "./maUrl.vue?vue&type=style&index=0&id=5bd8e550&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd8e550",
  null
  
)

export default component.exports